import { useMemo } from "react";

import { useAxios } from "@/lib/hooks";

import {
  createBrain,
  deleteBrain,
  getBrain,
  getBrains,
  updateBrain,
} from "./brain";
import { CreateBrainInput, UpdateBrainInput } from "./types";

// Backward compatibility alias
export type CreateKnowledgeBaseInput = CreateBrainInput;

export const useKnowledgeBaseApi = () => {
  const { axiosInstance } = useAxios();

  return useMemo(
    () => ({
      createKnowledgeBase: async (knowledgeBase: CreateBrainInput) =>
        createBrain(knowledgeBase, axiosInstance),
      deleteKnowledgeBase: async (id: string) => deleteBrain(id, axiosInstance),
      getKnowledgeBases: async () => getBrains(axiosInstance),
      getKnowledgeBase: async (id: string) => getBrain(id, axiosInstance),
      updateKnowledgeBase: async (
        knowledgeBaseId: string,
        knowledgeBase: UpdateBrainInput,
      ) => updateBrain(knowledgeBaseId, knowledgeBase, axiosInstance),
    }),
    [axiosInstance],
  );
};

// Backward compatibility alias
export const useBrainApi = useKnowledgeBaseApi;
